import api from "../store/api.ts";
import {unwrapData} from "../store/apiResponse.ts";
import {ChatLoginResponse, ConfigResponse} from "./chatServiceTypes.ts";

export const chatApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<ChatLoginResponse, {deviceId: string | null}>({
      query: (body) => ({
        url: `/api/v1/chats/login`,
        method: 'POST',
        body: body,

      }),
      transformResponse: (_response, meta) => {
        if (meta) {
          const accessToken = meta.response?.headers.get('x-access-token');
          const refreshToken = meta.response?.headers.get('x-refresh-token');
          const expiresInMsHeader = meta.response?.headers.get('x-expires-in-ms');
          const expiresInMs = expiresInMsHeader ? Number.parseInt(expiresInMsHeader, 10) : NaN;

          if (!accessToken) {
            throw new Error('No tokens received from chat login');
          }

          return {
            accessToken,
            refreshToken: refreshToken ?? undefined,
            expiresInMs: Number.isNaN(expiresInMs) ? undefined : expiresInMs,
          };
        } else {
          throw new Error('Invalid login response');
        }
      },
    }),
    isChatEnabled: builder.query<boolean, void>({
      query: () => ({
        url: `/api/v1/features/enabled`,
        method: 'GET',
      }),
        transformResponse: (response: ConfigResponse) => {
            const features = unwrapData(response);
            if (features) {
            return features.find(el => el.feature === 'chat')?.enabled == true;
            } else {
            throw new Error('Invalid response from chat feature check');
            }
        },
    }),
    isAiBotEnabled: builder.query<boolean, void>({
      query: () => ({
        url: `/api/v1/features/enabled`,
        method: 'GET',
      }),
        transformResponse: (response: ConfigResponse) => {
            const features = unwrapData(response);
            if (features) {
            return features.find(el => el.feature === 'ai-bot')?.enabled == true;
            } else {
            throw new Error('Invalid response from PhoneHQ AI feature check');
            }
        },
    }),
    isChatWebhooksEnabled: builder.query<boolean, void>({
      query: () => '/api/v1/features/enabled',
      transformResponse: (response: ConfigResponse) =>
        unwrapData(response)?.some(feature => feature.feature === 'chat-webhooks' && feature.enabled) === true,
    }),
    isCallAskAiEnabled: builder.query<boolean, void>({
      query: () => '/api/v1/features/enabled',
      transformResponse: (response: ConfigResponse) =>
        unwrapData(response)?.some(feature => feature.feature === 'call-ask-ai' && feature.enabled) === true,
    }),
    isAiKnowledgeBaseEnabled: builder.query<boolean, void>({
      query: () => ({
        url: `/api/v1/features/enabled`,
        method: 'GET',
      }),
        transformResponse: (response: ConfigResponse) => {
            if (response) {
            return response.data.find(el => el.feature === 'ai-knowledge-base')?.enabled == true;
            } else {
            throw new Error('Invalid response from AI knowledge base feature check');
            }
        },
    }),
    isEnsEnabled: builder.query<boolean, void>({
      query: () => ({
        url: `/api/v1/features/enabled`,
        method: 'GET',
      }),
        transformResponse: (response: ConfigResponse) => {
            const features = unwrapData(response);
            if (features) {
            return features.find(el => el.feature === 'ens')?.enabled == true;
            } else {
            throw new Error('Invalid response from ENS feature check');
            }
        },
    }),
  }),
});

export const {
    useLoginMutation,
    useIsChatEnabledQuery,
    useIsAiBotEnabledQuery,
    useIsChatWebhooksEnabledQuery,
    useIsCallAskAiEnabledQuery,
    useIsAiKnowledgeBaseEnabledQuery,
    useIsEnsEnabledQuery
} = chatApi;
